import { Routes } from '@angular/router';
import { MpsLoggedInGuard } from '../../../mps/mps-guards';
import {IsAdminGuard} from 'src/app/guards/is-admin.guard';
import {HomeComponent} from './components/home/home.component';

export const routes: Routes = [
    {
        path: 'secondees-list',
        loadChildren: () => import('../secondees-list/secondees-list.module').then((m) => m.SecondeesListModule),
        canActivate: [MpsLoggedInGuard],
    },
    {
        path: 'interview',
        loadChildren: () => import('../interview/interview.module').then((m) => m.InterviewModule),
        canActivate: [MpsLoggedInGuard],
    },
    {
        path: 'administration',
        loadChildren: () => import('../administration/administration.module').then((m) => m.AdministrationModule),
        canActivate: [MpsLoggedInGuard, IsAdminGuard],
    },
    { path: '**', redirectTo: '/', pathMatch: 'full' }
];